<template>
  <section class="subBtnBox" :class="customPosifix? 'posifix':''">
    <template v-if="customContent">
      <slot name="customContent"></slot>
    </template>
    <template v-else>
      <el-button class="btn cancelBtn" @click="cancel" v-if="!cancelBtnHide">
        {{ cancelTextName }}
      </el-button>
      <el-button class="btn" type="primary" @click="sub" v-if="!comfirmBtnHide">
        {{ comfirmTextName }}
      </el-button>
    </template>
  </section>
</template>

<script>
import {
  mapMutations,
} from 'vuex';
export default {
  props: {
    customContent: {
      type: Boolean,
      default: false,
    },
    customCancel: {
      type: Boolean,
      default: false,
    },
    cancelTextName: {
      type: String,
      default: '取消',
    },
    cancelBtnHide: {
      type: Boolean,
      default: false,
    },
    comfirmBtnHide: {
      type: Boolean,
      default: false,
    },
    comfirmTextName: {
      type: String,
      default: '保存',
    },
    customSubmit: {
      type: Boolean,
      default: false,
    },
    // 点击取消后是否停留在当前页（true 为默认保持在当前页）
    cancelStayInCurrentPage: {
      type: Boolean,
      default: true,
    },
    // 点击提交后是否停留在当前页（false 为默认返回第一页）
    subStayInCurrentPage: {
      type: Boolean,
      default: false,
    },
    customPosifix: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    cancel () {
      if (this.cancelStayInCurrentPage) {
        sessionStorage.setItem('stayInCurrentPage', 'true');
      } else {
        sessionStorage.removeItem('stayInCurrentPage');
      }
      if (this.customCancel) {
        this.$emit('cancel');
      } else {
        this.close();
      }
    },
    sub () {
      if (this.subStayInCurrentPage) {
        sessionStorage.setItem('stayInCurrentPage', 'true');
      } else {
        sessionStorage.removeItem('stayInCurrentPage');
      }
      if (this.customSubmit) {
        this.$emit('customSub');
      } else {
        this.$emit('sub');
      }
    },
    ...mapMutations({
      editPageData: 'user/editPageData',
    }),
  },
};
</script>

<style scoped lang="scss">
.subBtnBox {
  height: 64px;
  line-height: 64px;
  width: 100%;
  background: rgba(255, 255, 255, 0.8);
  bottom: 0;
  right: 0;
  text-align: center;
  box-sizing: border-box;
  z-index: 9;
  .btn {
    width: 160px;
    height: 40px;
  }
  .cancelBtn {
    margin-right: 24px;
    margin-left: 200px;
  }
}
</style>
